import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("新增子分类")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("分类名称:")
const _hoisted_18 = { style: {"margin-top":"10px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("编码:")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "分类管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: false,
          style: {"margin-top":"10px"},
          onChange: _ctx.handleTableChange,
          "row-key": (record)=>record.id
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (record.pid == 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        onClick: ($event: any) => (_ctx.addSon(record)),
                        style: {"margin-left":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否启用该内容?",
                    "ok-text": "启用",
                    "cancel-text": "禁用",
                    onConfirm: ($event: any) => (_ctx.onDel(record,1)),
                    onCancel: ($event: any) => (_ctx.onDel(record,0))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "onChange", "row-key"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible2) = $event)),
      title: "查看子分类",
      width: "50%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.sonData,
          columns: _ctx.columns2,
          bordered: "",
          pagination: false,
          style: {"margin-top":"0px"},
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(record.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit2(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否启用该内容?",
                    "ok-text": "启用",
                    "cancel-text": "禁用",
                    onConfirm: ($event: any) => (_ctx.onDel(record,1)),
                    onCancel: ($event: any) => (_ctx.onDel(record,0))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "onChange"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk,
      width: "20%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_17,
          _createVNode(_component_a_input, {
            value: _ctx.name,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: "分类名称",
            style: {"margin-top":"10px"}
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_a_input, {
            value: _ctx.sn,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sn) = $event)),
            placeholder: "编码",
            style: {"margin-top":"10px"}
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible3,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible3) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk2,
      width: "20%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.form,
          "label-col": { span: 4 },
          "wrapper-col": { span: 18 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "一级分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.form.first,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.first) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getSecond( $event, $event))),
                  placeholder: "请选择一级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "二级分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.form.second,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.second) = $event)),
                  placeholder: "请选择二级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sonData, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "职位名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入职位名",
                  value: _ctx.form.name,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}